import { render, staticRenderFns } from "./About.vue?vue&type=template&id=a12ae1d6&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports